import CapitalSpinner from './CapitalSpinner';

interface PanelLoaderProps {
    /** Omitido = visível; `<PanelLoader />` significa "carregando". */
    visible?: boolean;
}

/** Cobre o bloco (pai `relative`) com o spinner único da Capital. */
const PanelLoader = ({ visible = true }: PanelLoaderProps) => {
    if (!visible) return null;
    return (
        <div className="absolute inset-0 z-20 flex items-center justify-center bg-white dark:bg-surface-card rounded-md">
            <CapitalSpinner size={48} />
        </div>
    );
};

export default PanelLoader;
